module.exports = __webpack_public_path__ + "static/media/agency.0fcb5787.mp4";